import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export default function BackArrow (){

    return(
        <div className='absolute top-0 left-full -translate-x-16 w-16 h-16 mt-4'>
            <a href="/portfolio/projects" className="link-icon">
                <FontAwesomeIcon icon={faArrowLeft} size='2xl'/>
            </a>
        </div>
    )

}